import styled from "styled-components";

export const LoadingContainer = styled.div`
  position: fixed;
  z-index: 99999;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  font-size: 70px;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  span {
    display: inline-block;
    animation: rotate 1s linear infinite;
    svg {
      margin: 0;
      display: block;
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const HeaderContainer = styled.header`
  padding: 0;
  position: relative;
  background: #191f28;
  &.info {
    &.scheduler {
      background: #ffd9f2;
      .headerInner nav .dropdown:hover .dropdown-menu {
        background: #ffd9f2;
      }
    }
    &.project {
      background: #fff299;
      .headerInner nav .dropdown:hover .dropdown-menu {
        background: #fff299;
      }
    }
    &.shop {
      background: #eaf7ed;
      .headerInner nav .dropdown:hover .dropdown-menu {
        background: #eaf7ed;
      }
    }
  }
  &.group {
    background: #fef9f3;
    .headerInner nav .dropdown:hover .dropdown-menu {
      background: #fef9f3;
    }
  }
  &.main {
    .headerInner nav .dropdown:hover .dropdown-menu {
      background: #191f28;
    }
  }
  &.mypage {
    padding: 0;
    position: absolute;
    background: transparent;
    top: 0;
    left: 0;
    color: #000;
    &.dark {
      a,
      button {
        color: #fff;
      }
      .headerInner nav .dropdown .dropdown-menu {
        background: #1e1f21;
      }
    }
    &.white {
      .headerInner nav .dropdown .dropdown-menu {
        background: rgba(255, 255, 255, 0.3);
        border-radius: 10px;
      }
    }
  }
  &.group,
  &.scheduler,
  &.project,
  &.shop,
  &.mypage.white {
    .headerInner {
      .logo,
      .sideMenu,
      a,
      .headerBtnArea button,
      .headerBtnArea a,
      .buttons .notify {
        color: #000;
      }
    }
  }
  h1 {
    display: none;
  }
  .headerInner {
    max-width: 1440px;
    padding: 10px 20px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .logo {
      font-size: 22px;
      color: #fff;
      font-weight: 700;
      height: auto;
    }
    svg {
      display: block;
      margin: auto;
    }
    .notify,
    .search {
      font-size: 20px;
    }
    nav {
      width: calc(100% - 700px);
      text-align: left;
      > ul {
        display: flex;
        flex-direction: row;
      }
      .dropdown {
        position: relative;
        display: flex;
        align-items: center;
        width: 150px;
        padding: 9px 0;
        a {
          display: inline-block;
          padding: 0;
          text-align: center;
          width: 100%;
        }
        .dropdown-menu {
          display: block;
          max-height: 0;
          padding: 0;
          width: 100%;
          opacity: 0;
          transform: none;
          position: absolute;
          overflow: hidden;
          transition: 0.5s;
          top: 100%;
          left: 50%;
          transform: translate(-50%, 0);
          gap: 30px;
          white-space: nowrap;
          z-index: 33;
          li {
            width: auto;
          }
        }
        &:hover {
          .dropdown-menu {
            max-height: 300px;
            opacity: 1;
          }
        }
      }
      li {
        margin-right: 0;
      }
    }
    .dropdown-menu {
      width: 150%;
      padding: 20px 0;
      li a {
        padding: 0;
        transition: 0.3s;
        &:hover {
          font-weight: 700;
          transform: scale(1.1);
        }
      }
    }
    .buttons {
      display: flex;
      font-size: 14px;
      align-items: center;
      gap: 10px;
      button,
      a,
      .notify {
        border: none;
        background: transparent;
        color: #fff;
      }
      button:nth-child(2),
      button:nth-child(4) {
        margin-right: 30px;
      }
      .notify {
        position: relative;
        cursor: pointer;
        span {
          position: absolute;
          top: 0;
          left: 100%;
          font-size: 0;
          /* transform: translateX(3px); */
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: tomato;
          text-align: center;
          line-height: 15px;
        }
      }
    }
    .sideMenu {
      display: flex;
      font-size: 28px;
      border: none;
      background: transparent;
      color: #fff;
    }
  }
  @media screen and (max-width: 1050px) {
  }
  @media screen and (max-width: 768px) {
    .headerInner {
      .login_menu {
        width: auto;
        transform: translateY(0);
      }
      img.logo {
        width: 100px;
        height: 35px;
      }
    }
  }
`;

export const SideMenuContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999999;
  background: #191f28;
  transition: 0.3s;
  a,
  button,
  svg path {
    stroke: #fff;
    color: #fff;
  }
  &.mypage {
    background: rgb(238, 218, 217);
    background: linear-gradient(
      90deg,
      rgba(238, 218, 217, 1) 0%,
      rgba(247, 191, 176, 1) 35%,
      rgba(238, 218, 217, 1) 100%
    );
    transition: 0.3s;
    a,
    button,
    svg path {
      stroke: #000;
      color: #000;
    }
    .wrapper .authButtons .buttons {
      a,
      button {
        background: rgba(255, 255, 255, 0.5);
      }
    }
    &.dark {
      background: #1e1f21;
      .sideMenuInfo {
        .logo,
        a,
        button,
        svg path {
          stroke: #fff;
          color: #fff;
        }
      }
      .wrapper {
        .sideMenuInfo .buttons button:last-child,
        svg path,
        .toggle,
        .menuItem li a {
          stroke: #fff;
          color: #fff;
        }
        .authButtons .buttons {
          a,
          button {
            background: rgba(0, 0, 0, 0.5);
          }
        }
      }
    }
  }
  button {
    border: none;
    background: transparent;
  }
  .wrapper {
    padding: 20px;
    width: 100%;
    height: 100%;
    font-size: 18px;
    .sideMenuInfo {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 50px;
      .logo {
        font-size: 20px;
        font-weight: 600;
      }
      .buttons {
        font-size: 25px;
        display: flex;
        align-items: center;
        gap: 10px;
        button,
        a {
          width: 25px;
          height: 25px;
          text-align: center;
          &:last-child {
            margin-left: 20px;
          }
          display: flex;
        }
        a {
          position: relative;
          span {
            position: absolute;
            top: 0;
            left: 100%;
            font-size: 0;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background: tomato;
            text-align: center;
          }
        }
      }
    }
    .authButtons {
      margin-top: 50px;
      .buttons {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 10px;
        button,
        a {
          display: block;
          width: 100%;
          text-align: center;
          background: rgba(255, 255, 255, 0.1);
          padding: 10px 0;
          border-radius: 10px;
          font-size: 14px;
        }
        .login {
          order: 1;
        }
        .type {
          order: 2;
        }
        .logout {
          order: 4;
        }
        .mypage {
          order: 3;
        }
      }
    }
    .toggle {
      width: 100%;
      margin: 10px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span:first-child {
        font-weight: 700;
      }
      .icon {
        font-size: 20px;
        svg {
          display: block;
        }
      }
    }
    .menuItem {
      padding-left: 20px;
      li {
        margin: 10px;
      }
    }
  }
`;

export const GridSideMenuContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 10;
  .bg {
    max-width: 1440px;
    padding: 0 20px;
    width: 100%;
    height: 100%;
    position: relative;
    margin: auto;
  }
  .menu {
    position: absolute;
    top: 80px;
    right: 10px;
    background: #fff;
    border-radius: 10px;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    color: #000;
    > div {
      position: relative;
      max-width: 300px;
      .arrow {
        position: absolute;
        top: 1px;
        transform: translateY(-100%);
        right: 9px;
        width: 0;
        height: 0;
        border-bottom: 15px solid rgb(239, 239, 239);
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
      }
      .arrow + div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        background: rgb(239, 239, 239);
        border-bottom: 2px solid #efefef;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        .logo {
          font-size: 20px;
          display: flex;
          align-items: center;
          gap: 5px;
          img {
            width: 30px;
          }
        }
        .close {
          button {
            font-size: 25px;
            border: none;
            background: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
      .cont {
        max-height: 450px;
        overflow: auto;
        display: flex;
        flex-direction: column;
        .tit {
          font-weight: 700;
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 22px;
          padding: 10px;
          background: #efefef;
          border-radius: 10px 10px 0 0;
          span {
            font-size: 18px;
          }
        }
        .border {
          border-top: 1px solid #efefef;
        }
        ul {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin: 10px;
          li {
            width: calc((100% - 30px) / 4);
            padding: 10px 0;
            text-align: center;
            font-size: 14px;
            cursor: pointer;
            .icon {
              display: flex;
              justify-content: center;
              font-size: 20px;
              margin-bottom: 5px;
            }
          }
        }
      }
    }
    @media screen and (max-width: 1280px) {
      .bg {
        width: 96%;
      }
    }
    @media screen and (max-width: 1050px) {
      .bg {
        padding: 0;
      }
      .menu {
        right: 0;
      }
    }
    @media screen and (max-width: 767px) {
      .bg {
        width: 90%;
      }
    }
  }
`;

export const UseAppContainer = styled.div`
  position: fixed;
  z-index: 10001;
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  .modal {
    position: absolute;
    width: 332px;
    height: 268px;
    background: #fff;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 20px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    .info {
      display: flex;
      align-items: center;
      gap: 20px;
      margin-bottom: 20px;
      img {
        width: 90px;
        height: 90px;
      }
      > div {
        width: calc(100% - 110px);
      }
      h2 {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 12px;
        white-space: pre-line;
      }
      p {
        font-size: 12px;
        color: #979797;
      }
    }
    .actions {
      flex-grow: 1;
      min-height: 0;
      button {
        display: block;
        height: calc(50% - 6px);
        width: 100%;
        border: none;
        font-size: 20px;
        border-radius: 5px;
        &:first-child {
          margin-bottom: 12px;
          background: #333333;
          color: #fff;
        }
        &:last-child {
          background: transparent;
          color: #b8b8b8;
        }
      }
    }
  }
`;

export const MediaViewerContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  /* 바깥 딤 (현재 연보라 배경이랑 어울리는 톤) */
  background: rgba(24, 18, 38, 0.9);
  z-index: 9999;

  /* 가운데 카드처럼 보이게 가로만 정렬 */
  display: flex;
  justify-content: center;

  .mySwiper {
    width: 100%;
    max-width: 1100px;
    height: 100%;
    background: #fff;
    margin: 0 auto;
    border-radius: 16px;
    overflow: hidden;
    box-shadow:
      0 20px 45px rgba(0, 0, 0, 0.4),
      0 0 0 1px rgba(255, 255, 255, 0.04);
  }

  &.dark {
    .mySwiper {
      background: #050505;
      color: #eee;
    }
    button {
      color: #eee;
    }
  }

  svg {
    display: block;
    margin: 0;
  }

  img,
  video {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    user-select: none;
  }

  button {
    background: transparent;
    border: none;
    user-select: none;
    cursor: pointer;
  }

  .swiper-slide {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    background: transparent;
  }

  @media screen and (max-width: 767px) {
    .mySwiper {
      max-width: 100%;
      border-radius: 0;
      box-shadow: none;
    }
    .chat {
      display: none;
    }

    /* 모바일에서 슬라이드 전체를 세로 레이아웃 + 전체 높이 100vh */
    .swiper-slide {
      flex-direction: column;
      height: 100vh;
      flex-wrap: nowrap;
    }
  }

  /* 데스크탑 말풍선 버튼 */
  .chat {
    position: absolute;
    top: 90px;
    right: 24px;
    z-index: 10;
    background: rgba(0, 0, 0, 0.85);
    color: #eee;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 46px;
    height: 46px;
    border-radius: 50%;
    font-size: 22px;
    box-shadow:
      0 12px 28px rgba(0, 0, 0, 0.55),
      0 0 0 1px rgba(255, 255, 255, 0.14);
    backdrop-filter: blur(12px);
    transition:
      transform 0.18s ease-out,
      box-shadow 0.18s ease-out,
      background 0.18s ease-out;

    &:hover {
      transform: translateY(-1px) scale(1.02);
      box-shadow:
        0 16px 34px rgba(0, 0, 0, 0.65),
        0 0 0 1px rgba(255, 255, 255, 0.2);
      background: rgba(5, 5, 5, 0.98);
    }

    &:active {
      transform: translateY(0) scale(0.96);
      box-shadow: 0 8px 18px rgba(0, 0, 0, 0.55);
    }
  }

  @media screen and (max-width: 767px) {
    .mySwiper {
      max-width: 100%;
      border-radius: 0;
      box-shadow: none;
    }
    .chat {
      display: none; /* 모바일에서는 말풍선 버튼 안 씀 */
    }
  }
`;

export const MediaHeaderContainer = styled.div`
  width: 100%;
  padding: 0 20px;
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  letter-spacing: 0;
  line-height: normal;
  background: #ffffff;
  border-bottom: 1px solid #f0f0f0;

  span {
    font-size: 15px;
    font-weight: 700;
    letter-spacing: -0.01em;
  }

  button {
    font-size: 22px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 999px;
    transition:
      background 0.16s ease-out,
      transform 0.12s ease-out;

    &:hover {
      background: rgba(0, 0, 0, 0.04);
      transform: scale(1.02);
    }

    &:active {
      transform: scale(0.95);
      background: rgba(0, 0, 0, 0.06);
    }
  }

  @media screen and (max-width: 767px) {
    height: 56px;
    padding: 0 16px;

    span {
      font-size: 14px;
    }
  }
`;

export const MediaContentContainer = styled.div`
  /* 헤더(70) + 푸터(70) 제외한 영역 전체를 항상 차지 */
  height: 100%;
  background: #000;  /* 검정 배경 위에 사진 */

  /* 댓글 열려 있으면 70%, 아니면 100% */
  width: ${(props) => (props.isComment ? "70%" : "100%")};

  .media {
    width: 100%;
    height: 100%;           /* 이 박스 높이가 고정됨 → 여기 안에서만 놀게 */
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    box-sizing: border-box;
  }

  /* 이 부분이 진짜 핵심 */
  .media img,
  .media video {
    width: 100%;
    height: 100%;           /* 항상 컨테이너 높이에 맞춤 */
    object-fit: cover;      /* 잘리지 않아야 하면 contain, 높이 통일은 cover */
    display: block;
  }

  @media screen and (max-width: 1050px) {
    width: 100%;
  }

  @media screen and (max-width: 767px) {
    /* 모바일에서도 똑같이 “헤더+푸터 제외 영역 전체”를 이미지 박스로 사용 */
    height: calc(100vh - 156px - 152px); /* 모바일 헤더/푸터 높이에 맞춰 조정 */
  }
`;


export const MediaCommentContainer = styled.div`
  height: calc(100% - 140px);
  background: #fafafa;
  color: #333;
  position: relative;
  font-size: 14px;
  letter-spacing: 0;
  line-height: normal;
  border-left: 1px solid #e5e5e5;
  display: flex;
  flex-direction: column;
  transition: width 0.22s ease-out;

  &.open {
    width: 30%;
    min-width: 280px;
  }

  &.close {
    width: 0;
    overflow: hidden;
  }

  .info {
    padding: 0 16px;
    height: 46px;
    border-bottom: 1px solid #ececec;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background: #fafafa;

    button {
      color: #555;
      font-size: 20px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 2px;
      border-radius: 999px;
      transition:
        background 0.16s ease-out,
        transform 0.12s ease-out;

      &:hover {
        background: rgba(0, 0, 0, 0.04);
        transform: translateX(1px);
      }

      &:active {
        transform: translateX(0);
      }
    }
  }

  ul {
    padding: 14px 16px 10px;
    height: calc(100% - 106px); /* info(46) + form(60) 기준 */
    overflow-y: auto;

    li {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      gap: 6px;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      img {
        width: 28px;
        height: 28px;
        border-radius: 999px;
        object-fit: cover;
      }

      div {
        width: 100%;

        strong {
          display: block;
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 2px;
        }

        p {
          font-size: 13px;
          line-height: 1.4;
          margin-bottom: 2px;
          word-break: break-word;
        }

        span {
          font-size: 11px;
          color: #9b9b9b;
        }
      }

      .writer {
        width: calc(100% - 32px);
      }

      button {
        width: 28px;
        height: 28px;
        color: #777;
        font-size: 18px;
        border-radius: 999px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition:
          background 0.16s ease-out,
          color 0.16s ease-out;

        svg {
          display: block;
          margin: auto;
        }

        &:hover {
          color: #333;
          background: rgba(0, 0, 0, 0.04);
        }
      }

      &.not {
        font-size: 13px;
        color: #9b9b9b;
      }
    }
  }

  .form {
    height: 60px;
    position: relative;
    padding: 10px 12px 12px;
    border-top: 1px solid #e6e6e6;
    background: #fafafa;
    box-sizing: border-box;

    input[type="text"] {
      height: 100%;
      width: 100%;
      background: #ffffff;
      color: #333;
      border: 1px solid #d3d3d3;
      border-radius: 999px;
      padding: 0 44px 0 16px;
      font-size: 13px;

      &:focus {
        outline: none;
        border-color: #999;
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06);
      }

      &::placeholder {
        color: #b0b0b0;
      }
    }

    button {
      width: 28px;
      height: 28px;
      position: absolute;
      right: 18px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 15px;
      color: #333;
      background: #ffffff;
      border-radius: 999px;
      border: 1px solid #dedede;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);

      svg {
        margin: auto;
      }

      &:active {
        transform: translateY(-50%) scale(0.95);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
      }
    }
  }

  /* 모바일 댓글 높이 제한 */
  @media screen and (max-width: 767px) {
    position: relative;
    width: 100% !important;
    height: auto;
    border-left: none;
    border-top: 1px solid #ececec;
    background: #ffffff;

    &.open,
    &.close {
      width: 100%;
      overflow: visible;
    }

    .info {
      display: false;
    }

    /* 댓글 전체 컨테이너: 높이 제한 + flex:0 */
    flex: 0 0 auto;
    max-height: 40vh;     /* ← 여기 숫자만 바꾸면 댓글 영역 비율 조절 */
    overflow-y: hidden;   /* 전체는 숨기고, ul만 스크롤 */

    ul {
      padding: 10px 14px 6px;
      max-height: calc(30vh - 60px);  /* form(60px) 뺀 영역 */
      overflow-y: auto;               /* 댓글 리스트 자체 스크롤 */
    }

    .form {
      position: sticky;
      bottom: 0;
      padding: 8px 10px 10px;
      background: linear-gradient(to top, #ffffff, rgba(255, 255, 255, 0.96));

      input[type="text"] {
        background: #f6f6f6;
        border: none;
      }
    }
  }

  /* 태블릿에서 사이드 폭 살짝 줄이기 */
  @media screen and (max-width: 1050px) {
    &.open {
      width: 260px;
    }
  }

  /* 모바일: 인스타처럼 아래에 붙고 내부 스크롤 */
  @media screen and (max-width: 767px) {
    position: relative;
    width: 100% !important;
    height: auto;
    border-left: none;
    border-top: 1px solid #ececec;
    background: #ffffff;

    &.open,
    &.close {
      width: 100%;
      overflow: visible;
    }

    .info {
      display: none; /* 상단 화살표 버튼 숨김 */
    }

    /* 댓글 컨테이너가 남은 영역 전체 차지 */
    flex: 1 1 0;
    display: flex;
    flex-direction: column;

    ul {
      padding: 10px 14px 6px;
      flex: 1 1 0;
      height: auto;
      max-height: none;
      overflow-y: auto;
    }

    .form {
      position: sticky;
      bottom: 0;
      padding: 8px 10px 10px;
      background: linear-gradient(to top, #ffffff, rgba(255, 255, 255, 0.96));

      input[type="text"] {
        background: #f6f6f6;
        border: none;
      }
    }
  }
`;

export const MediaFooterContainer = styled.div`
  width: 100%;
  padding: 0 20px;
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  letter-spacing: 0;
  line-height: normal;
  background: #ffffff;
  border-top: 1px solid #f0f0f0;

  .info,
  button {
    display: flex;
    align-items: center;
  }

  .info {
    gap: 18px;
    span {
      display: block;
      text-align: left;
      &:nth-child(1) {
        font-size: 11px;
        color: #9b9b9b;
      }
      &:nth-child(2) {
        font-size: 13px;
        color: #222;
        font-weight: 500;
      }
    }
  }

  button {
    gap: 8px;
    font-size: 13px;
    padding: 6px 14px;
    border-radius: 999px;
    border: 1px solid #e5e5e5;
    background: #ffffff;
    color: #333;
    transition:
      background 0.16s ease-out,
      box-shadow 0.16s ease-out,
      transform 0.1s ease-out;

    svg {
      font-size: 16px;
    }

    &:hover {
      background: #f8f8f8;
      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.14);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);
    }
  }

  @media screen and (max-width: 767px) {
    padding: 0 14px;
    height: 52px;
    font-size: 12px;

    .info {
      gap: 10px;
      span:nth-child(2) {
        font-size: 12px;
      }
    }

    button {
      padding: 4px 10px;
      font-size: 12px;
    }
  }
`;


export const CustomInput = styled.label`
  position: relative;
  cursor: pointer;
  height: 20px;
  width: 20px;
  &.block {
    display: block;
    margin: auto;
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    padding: 0;
    width: 0;
    height: 0;
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    border: 2px solid #ccc;
    border-radius: 6px;
    background-color: transparent;
    transition: all 0.3s ease;
    &:after {
      content: "";
      position: absolute;
      display: none;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(45deg) scale(0);
      width: 7px;
      height: 13px;
      border: solid #fff;
      border-width: 0 3px 3px 0;
    }
  }
  input:checked ~ .checkmark {
    /* background-color: #000; */
    /* border-color: #000; */
    &:after {
      display: block;
      /* animation: checkboxExpand 0.3s ease forwards; */
      transform: translate(-50%, -50%) rotate(45deg) scale(1);
      border-color: #0074ca;
    }
  }
  &:hover .checkmark {
    background-color: #efefef;
  }

  @keyframes checkboxExpand {
    0% {
      transform: translate(-50%, -50%) rotate(45deg) scale(0);
    }
    100% {
      transform: translate(-50%, -50%) rotate(45deg) scale(1);
    }
  }
`;
